// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"04337936daf6a2e45dd7","703":"9a10ce088d4d8f33b891","886":"2e1a554b51b3acf86362","954":"9abcb25ca58f1afb85bf"}[chunkId] + ".js";
};